export const call_permission= {
    soultip_permission:['view_tip']
}